import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';

import {
  ResetKeybindingsItem,
  UnassignKeybindingsItem,
} from './components/items';
import styles from './menu.module.scss';

export const KeyboardKeybindingsTableRowMenu = (): JSX.Element => {
  return (
    <DropdownButton
      noArrow
      fixed
      icon="dots-v"
      buttonProps={{ variant: 'tertiary' }}
      dropdownProps={{ className: styles.dropdown, fixed: true }}
      dropdown={
        <ButtonList>
          <UnassignKeybindingsItem />
          <ResetKeybindingsItem />
        </ButtonList>
      }
    />
  );
};
